import { createGlobalStyle, css } from 'styled-components';

import { CommonTheme } from './typings';

export const CommonGlobalStyle = createGlobalStyle<{ theme: CommonTheme }>`
  ${({ theme }: { theme: CommonTheme }) => css`
    html {
      box-sizing: border-box;
      ${theme.media.mobile`
        font-size: 18px;
      `};
      ${theme.media.smallDesktop`
        font-size: 20px;
      `};
    }
    body {
      color: ${theme.colors.primary.black.base};
      margin: 0px;
    }
    p {
      margin-block-start: 0;
      margin-block-end: 0;
    }
    * {
      font-family: ${theme.fonts.regular};
    }
    *,
    ::after,
    ::before {
      box-sizing: inherit;
    }
    a {
      color: ${theme.colors.primary.black.base};
    }
    fieldset {
      padding: 0px;
      margin: 0px;
      border: none;
      width: 100%;
    }

    .grecaptcha-badge {
      visibility: hidden;
    }

    .upload-widget .btn {
      border: none;
      padding: 0px;
      margin: 0px;
      line-height: unset;
      border-radius: unset;
      background-color: unset;
    }

    .upload-widget a {
      color: unset;
    }

    .upload-widget__controls--space button:not(:last-child) {
      margin-right: 0px;
    }

    /* Disable background scrolling while any Mention Me overlay is open */
    body:has([id^='mmMask'][style*='display: block']) {
      overflow: hidden;
    }
  `}
`;
